export interface DeleteReserveSetRequest {
  id: number
}

export function DeleteReserveSetRequestToJSON(
  value: DeleteReserveSetRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined
  }
}
